import React, { useEffect, useMemo, useState } from 'react';

const DEFAULT_THEME = {
  cardBg: 'linear-gradient(180deg, #0B1220 0%, rgba(11, 18, 32, 0.55) 100%)',
  border: 'rgba(148, 163, 184, 0.16)',
  shadow: '0 20px 55px rgba(2, 6, 23, 0.65)'
};

function SplitPanel({ left, right, style: styleOverride, theme: themeProp }) {
  const theme = themeProp || DEFAULT_THEME;
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') {
      return false;
    }
    return window.innerWidth <= 768;
  });

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const updateLayout = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    updateLayout();
    window.addEventListener('resize', updateLayout);
    return () => window.removeEventListener('resize', updateLayout);
  }, []);

  const styles = useMemo(() => {
    const card = {
      background: theme.cardBg,
      border: `1px solid ${theme.border}`,
      borderRadius: 20,
      boxShadow: theme.shadow
    };

    return {
      panel: {
        ...card,
        width: '100%',
        overflow: 'hidden',
        ...styleOverride
      },
      grid: {
        display: 'grid',
        gridTemplateColumns: isMobile ? 'minmax(0, 1fr)' : 'minmax(320px, 1.05fr) 1px minmax(320px, 0.95fr)',
        gridTemplateRows: isMobile ? 'auto 1px auto' : undefined,
        alignItems: 'stretch'
      },
      left: {
        padding: 28,
        display: 'flex',
        flexDirection: 'column'
      },
      right: {
        padding: 28
      },
      divider: {
        background: theme.border,
        width: isMobile ? '100%' : 1,
        height: isMobile ? 1 : '100%'
      }
    };
  }, [isMobile, styleOverride, theme]);

  return (
    <div style={styles.panel} role="region" aria-label="Split panel">
      <div style={styles.grid}>
        <aside style={styles.left} aria-label="Left content">
          {left}
        </aside>
        <div style={styles.divider} aria-hidden="true" />
        <section style={styles.right} aria-label="Right content">
          {right}
        </section>
      </div>
    </div>
  );
}

export default SplitPanel;
